  
import {ReactElement} from 'react';

 
import {useTranslation} from 'react-i18next';

import {useMediaQuery} from '@mui/material';
import {useTheme} from '@mui/material/styles';

import {CompanyDetails} from '../CompanyDetails/CompanyDetails';

import {DesktopDisplay} from './DesktopDisplay';
import {MobileDisplay} from './MobileDisplay';
import {JobPostingDetailsApplicant} from '../../../../../components/JobPostingDetails/JobPostingDetails';
import {CompanyProfile} from '../../../../company/profile/types';
import {JobPosting} from '../../../../company/recruiting/job-postings/types/JobPostingsTypes';
import {MatchLocation} from '../../../dashboard/types/ApplicantMatchesTypes';

export interface TabProps {
  tab: string | number;
  id: 'job' | 'company';
  component: ReactElement;
}
interface Props {
  jobPosting: JobPosting;
  companyProfile: CompanyProfile;
  locations: MatchLocation[];
  elementRef: (node: HTMLDivElement | null) => void;
}
export const CompanyInfoToggle = ({companyProfile, jobPosting, locations, elementRef}: Props) => {
  const theme = useTheme();
  const {t} = useTranslation();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const leftTab = t('applicantDashboard.matchDetailsView.jobsTab') || 'Job description';
  const rightTab = t('applicantDashboard.matchDetailsView.companyTab') || 'Company';

  const leftTabContent: TabProps = {
    tab: leftTab,
    id: 'job',
    component: <JobPostingDetailsApplicant jobPosting={jobPosting} />,
  };

  const rightTabContent: TabProps = {
    tab: rightTab,
    id: 'company',
    component: <CompanyDetails companyProfile={companyProfile} locations={locations} />,
  };

  return (
    <>
      {isXsScreen ? (
        <MobileDisplay leftTabContent={leftTabContent} rightTabContent={rightTabContent} />
      ) : (
        <DesktopDisplay elementRef={elementRef} leftTabContent={leftTabContent} rightTabContent={rightTabContent} />
      )}
    </>
  );
};
